import { render, staticRenderFns } from "./GoodsFlowList.vue?vue&type=template&id=0c87ec59&scoped=true&"
import script from "./GoodsFlowList.vue?vue&type=script&lang=js&"
export * from "./GoodsFlowList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsFlowList.vue?vue&type=style&index=0&id=0c87ec59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c87ec59",
  null
  
)

export default component.exports